import { Components } from '@mui/material/styles/components';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const FormLabelComponent: Components = {
  MuiFormLabel: {
    styleOverrides: {
      root: {
        ...ControllerFont.Heading250M,
        color: theme.palette.grey[600],
        letterSpacing: '0.02em',
      },
      asterisk: {
        color: theme.palette.error.main,
      },
    },
  },
};
